// import star1 from "../../assets/images/stars/1.svg";
// import star2 from "../../assets/images/stars/2.svg";
// import star3 from "../../assets/images/stars/3.svg";

import partyPopper from '../../assets/images/party_popper.png';

// Styles
import "./styles.scss";

function StatusCard(props) {
  return (
    <div className="status-card">
      <div className="star-section">
        {/* <img src={star1} className="image-rating" alt="" />
        <img src={star2} className="image-rating" alt="" />
        <img src={star3} className="image-rating" alt="" /> */}
        <img className='party-popper-img' src={partyPopper} alt="" />
      </div>

      <h4 className="title4">{props.title}</h4>

      <div className="score-box">
        <div className="box">
          <div className="text">Points Earned</div>
          <h4 className="title-lg text-center">{props.points}</h4>
        </div>
        <div className="box">
          <div className="text">Orders Served</div>
          <h4 className="title-lg text-center">{props.moves}</h4>
        </div>
      </div>
    </div>
  );
}

export default StatusCard;
